module.exports = __webpack_public_path__ + "static/media/03.757c8d85.JPG";